import { render } from "./ArchaicStatus.vue?vue&type=template&id=1351c106&scoped=true"
import script from "./ArchaicStatus.vue?vue&type=script&lang=js"
export * from "./ArchaicStatus.vue?vue&type=script&lang=js"

import "./ArchaicStatus.vue?vue&type=style&index=0&id=1351c106&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1351c106"]])

export default __exports__